// extracted by mini-css-extract-plugin
export default {"matchLine":"_2hLhe","subtext":"_32tT9"};